import { get } from "./get";

/**
 * Construct a string from a template and data.
 * The template is a string with placeholders for the data. E.g. "{{ name }} - {{ age }}"
 */
export function renderStringTemplate(template: string, data: any) {
  const regex = /{{\s*([^}]+)\s*}}/g;
  return template.replace(regex, (match, key) => {
    const result = get(data, key.trim(), "");
    if (!result) {
      console.warn(
        `Could not find key '${key.trim()}' in data`,
        `using ${match}.`
      );
    }
    return result;
  });
}
